import { v4 as uuidV4 } from "uuid";
import { LOGIN_URL_EVENT } from "./events";
import { getCookie } from "../cookie";
export default function initUlmUrl(config) {
    if (config.urlParams.domain) {
        var _a = config.urlParams, domain = _a.domain, pathname = _a.pathname, params = _a.params;
        var searchParams = Object.entries(params).reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            if (key === "state") {
                var ulmUuid = (_b = getCookie("acm_ulm_uuid")) !== null && _b !== void 0 ? _b : uuidV4();
                var state = encodeURIComponent(value)
                    .replace("DEVICE_ID_REPLACER", ulmUuid)
                    .replace("LOCATION_REPLACER", "{location}");
                acc.push("state=" + state);
            }
            else {
                acc.push(key + "=" + encodeURIComponent(value));
            }
            return acc;
        }, []);
        var search = searchParams.length ? "?" + searchParams.join("&") : "";
        var constructedUrl = domain + pathname + search;
        window.dispatchEvent(new CustomEvent(LOGIN_URL_EVENT, { detail: constructedUrl }));
        return constructedUrl;
    }
}
